import React from 'react'

import {
  Box,
  Color,
  Display,
  Heading2,
  JustifyContent,
  Space,
  TextAlign,
} from '@gousto-internal/citrus-react'

import { LandingPageButton, StepsWithImage } from '../../../../components'
import { FoodBoxPageSections, TargetUri, TrackingActions } from '../../../../types/tracking'
import { HOW_IT_WORKS_SECTION } from './config'
import { HowGoustoFoodBoxesWorkTypes } from '../../../../types/index'

export function FoodBoxHowItWorksSection({ startOnboarding }: HowGoustoFoodBoxesWorkTypes) {
  return (
    <Box paddingH={[8, 20]} paddingV={16} bg={Color.NeutralGrey_50}>
      <Box maxWidth="1200px" style={{ margin: '0 auto' }}>
        <Heading2 textAlign={[TextAlign.Left, null, null, TextAlign.Center]}>
          {HOW_IT_WORKS_SECTION.heading}
        </Heading2>
        <Space size={4} />
        <StepsWithImage steps={HOW_IT_WORKS_SECTION.steps} />
        <Space size={6} />
        <Box display={Display.Flex} justifyContent={JustifyContent.Center}>
          <LandingPageButton
            startOnboarding={startOnboarding}
            sectionName={FoodBoxPageSections.HOW_IT_WORKS_SECTION}
            target={TargetUri.SIGNUP}
            action={TrackingActions.CLICK_GET_STARTED}
          >
            {HOW_IT_WORKS_SECTION.ctaText}
          </LandingPageButton>
        </Box>
      </Box>
    </Box>
  )
}
